import React, { useState } from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';
import { useDiscreteMode } from "../../global/DiscreteMode";
import { useGetDataAssetByNameQuery } from "../../../../features/data_assets/dataAssetsApiSlice";
import { Link } from "react-router-dom";
import { tokens } from "../../../../theme";

Chart.register(ArcElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const getChartData = (data, type, range, isDiscreteMode) => {
  const labels = [];
  const dataset = [];
  let summary = 0;

  if (!data || !data.contributionMetrics) return { labels, datasets: [{ data: dataset }] };

  data.contributionMetrics.forEach((entry) => {
    if (entry.metrics && entry.metrics[range]) {
      entry.metrics[range].forEach((metric) => {
        const label = isDiscreteMode ? "Hidden" : entry.contributor;

        if (range === 'summary') {
          // Sum all metric values in summary array
          labels.push(label);
          dataset.push(metric[type]);
          summary += metric[type];
        } else if (metric.name === "Total") {
          // Process Total metrics for sevenDay and thirtyDay
          labels.push(label);
          dataset.push(metric[type]);
          summary += metric[type];
        }
      });
    }
  });

  return {
    labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: ['#A8E6CF', '#DCEDC1', '#FFD3B6', '#FFAAA5', '#FF8B94'],
        label: `${type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} (${range})`,
      },
    ],
    summary,
  };
};

const ADCCookiePool = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [chartType, setChartType] = useState("unique_pairs");
  const [range, setRange] = useState("sevenDay");
  const { isDiscreteMode } = useDiscreteMode();
  const { data: cookiePoolData, isLoading: isLoadingCookiePool } = useGetDataAssetByNameQuery("ADC Cookie Pool");

  const chartData = getChartData(cookiePoolData, chartType, range, isDiscreteMode);

  const handleChangeChartType = (event) => {
    setChartType(event.target.value);
  };

  const handleChangeRange = (event) => {
    setRange(event.target.value);
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'right',
        labels: {
          color: 'white',
          generateLabels: function (chart) {
            const labels = Chart.overrides.pie.plugins.legend.labels.generateLabels.call(this, chart);
            return labels.map((label) => {
              const value = chartData.datasets[0].data[label.index].toLocaleString();
              return {
                ...label,
                text: `${label.text}: ${value}`,
                font: { size: 10 },
              };
            });
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let label = chartData.labels[tooltipItem.dataIndex];
            let value = chartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex].toLocaleString();
            return `${label}: ${value}`;
          },
        },
      },
    },
  };

  return (
    <Paper sx={{ p: 4, minHeight: '33%', borderRadius: '20px', backgroundColor: colors.grey[700] }}>
      <Typography variant="h4" gutterBottom sx={{ alignSelf: 'flex-start' }}>
        <Link to="/console/media-adc" style={{ color: colors.blueAccent[200], textDecoration: 'none' }}>
          Cookie Pool Breakdown
        </Link>
      </Typography>
      <Box sx={{ width: '100%', padding: 2, borderRadius: 1 }}>
        <Pie data={chartData} options={options} />
      </Box>
    </Paper>
  );
};

export default ADCCookiePool;
